import { CalendarTimezoneData } from '@/common/types/calendarTimezone.type'
import { formatDateWithTimezone } from '@/common/utils/formatters'
import { useId } from 'react'
import { Tooltip } from 'react-tooltip'

interface BillDateWithTimezoneProps {
  date: string
  timezone?: CalendarTimezoneData
  hideTimezone?: boolean
}

const BillDateWithTimezone = ({ date, timezone, hideTimezone = false }: BillDateWithTimezoneProps) => {
  const uniqueId = useId()

  const ianaTimeZone = timezone?.identifier || 'America/Sao_Paulo'

  const dateInClientTimezone = formatDateWithTimezone(new Date(date), ianaTimeZone, hideTimezone ? false : true)

  const userTimezoneIdentifier = Intl.DateTimeFormat().resolvedOptions().timeZone

  const dateInUserTimezone = formatDateWithTimezone(new Date(date), userTimezoneIdentifier, true)

  const userTimezoneFormatted = userTimezoneIdentifier.replace(/\//g, ' - ').replace(/_/g, ' ')

  return (
    <>
      <p data-tooltip-id={uniqueId} className="cursor-default">
        {dateInClientTimezone}

        {!hideTimezone && (
          <span className="italic font-light ms-1">
            ({timezone ? timezone?.display_name || timezone.identifier : 'América - São Paulo'})
          </span>
        )}
      </p>

      {!hideTimezone && (
        <Tooltip id={uniqueId} className="z-50">
          <p>
            {dateInUserTimezone}

            <span className="italic font-light ms-1">({userTimezoneFormatted})</span>
          </p>
        </Tooltip>
      )}
    </>
  )
}

export default BillDateWithTimezone
